import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import PhoneFoundation from '../../../../../../components/Phone';
import './Phone.css';
export default function Phone(_ref) {
  var phone = _ref.phone;
  if (_isEmpty(phone)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(PhoneFoundation, {
    className: "phone",
    phone: phone
  });
}